import { render, staticRenderFns } from "./examPage.vue?vue&type=template&id=4c42fdbe&"
import script from "./examPage.vue?vue&type=script&lang=js&"
export * from "./examPage.vue?vue&type=script&lang=js&"
import style0 from "./examPage.vue?vue&type=style&index=0&id=4c42fdbe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports